import { http_client } from "@/plugins/http_client";

const notificaciones_URL = `${process.env.VUE_APP_URL_API_PLANILLA}/api/notificaciones`;

/**
 * Obtiene el listado paginado de notificaciones del usuario autenticado.
 *
 * @param {Object} params Filtros admitidos: leida, archivada, tipo, evento, buscar, per_page, page.
 * @returns {Promise<Object>} Respuesta con el paginador de notificaciones.
 */
const getNotificaciones = async (params = {}) =>
  await http_client(notificaciones_URL, params, "get");

/**
 * Obtiene la cantidad de notificaciones no leídas del usuario autenticado.
 *
 * @returns {Promise<Object>} Respuesta con la propiedad no_leidas.
 */
const getConteoNotificaciones = async () =>
  await http_client(`${notificaciones_URL}/conteo`, {}, "get");

/**
 * Resuelve la acción asociada a una notificación y la marca como leída.
 *
 * @param {string} id Identificador de la notificación.
 * @returns {Promise<Object>} Respuesta con la acción a ejecutar en el cliente.
 */
const ejecutarAccionNotificacion = async (id) =>
  await http_client(`${notificaciones_URL}/${id}/accion`, {}, "post");

/**
 * Marca una notificación como leída.
 *
 * @param {string} id Identificador de la notificación.
 * @returns {Promise<Object>} Respuesta con la notificación actualizada.
 */
const marcarNotificacionLeida = async (id) =>
  await http_client(`${notificaciones_URL}/${id}/leida`, {}, "patch");

/**
 * Marca como leídas todas las notificaciones del usuario autenticado.
 *
 * @returns {Promise<Object>} Respuesta con la cantidad de registros actualizados.
 */
const marcarTodasNotificacionesLeidas = async () =>
  await http_client(`${notificaciones_URL}/leidas`, {}, "patch");

export default {
  getNotificaciones,
  getConteoNotificaciones,
  ejecutarAccionNotificacion,
  marcarNotificacionLeida,
  marcarTodasNotificacionesLeidas
};
